import React from "react";
import ReactDOM from "react-dom";
import PropTypes from "prop-types";
import CatalogItem from "./Catalog/Item";

class BestSellers extends React.Component {
    render() {
        let products = this.props.products.map((record, index) => {
            if (index < 10) {
                return (
                    <div className="best-seller-card" key={ `card-${index}` }>
                        <CatalogItem details={record} />
                    </div>
                );
            }
        });

        return (
            <div className="best-seller-items">
                { products }
            </div>
        );
    }
}

BestSellers.propTypes = {
    products: PropTypes.array.isRequired
};

const bestSellersNode = document.querySelector("#bestSellers");

if (bestSellersNode) {
    ReactDOM.render(<BestSellers products={ [] } />, bestSellersNode);
}
